import api from "../common/services/liferay/api";
import {Liferay} from "../common/services/liferay/liferay";

export const getDetailCoordinationSettings = async (coordinationSettingId) => {

    const resp = await api(`/api/jsonws/invoke`, {
        method: 'POST',
        body: new URLSearchParams({
            cmd: JSON.stringify({
                '/digitalsale.deliverycoordinationsetting/get-coordination-setting': {
                    coordinationSettingId: Number(coordinationSettingId)
                },
            }),
            p_auth: Liferay.authToken
        }),
    });

    const data = await resp.json();

    return JSON.parse(data);
}